import { __decorate, __extends } from "tslib";
import { Component } from 'vue-property-decorator';
import BaseFilter from "FilterBar/BaseFilterBar/Base/BaseFilter";
import { FilterType } from "FilterBar/BaseFilterBar/Base/BaseFilterInterface";
var SubmitableFilter = /** @class */ (function (_super) {
    __extends(SubmitableFilter, _super);
    function SubmitableFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SubmitableFilter.prototype, "type", {
        get: function () {
            return FilterType.SUBMITABLE_FILTER;
        },
        enumerable: false,
        configurable: true
    });
    SubmitableFilter.prototype.updatePrevious = function (value) {
        this.previousModel = JSON.parse(JSON.stringify(value));
    };
    SubmitableFilter.prototype.submit = function () {
        this.updatePrevious(this.currentModel);
        this.$emit('changeValue', this.toJSON());
    };
    SubmitableFilter.prototype.changeValue = function (value) {
        this.currentModel = JSON.parse(JSON.stringify(value));
        this.$forceUpdate();
    };
    SubmitableFilter = __decorate([
        Component
    ], SubmitableFilter);
    return SubmitableFilter;
}(BaseFilter));
export default SubmitableFilter;
